import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { ClarityQuestion } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
export const ClarityQuestionSEO = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.clarityQuestion.details || $[1] !== props.clarityQuestion.question || $[2] !== props.clarityQuestion.questionId || $[3] !== props.clarityQuestion.slug) {
    const seoProps = {};
    seoProps.title = `Question: ${props.clarityQuestion.question}`;
    seoProps.description = props.clarityQuestion.details || props.clarityQuestion.question;
    seoProps.url = `/questions/${props.clarityQuestion.questionId}/${props.clarityQuestion.slug}`;
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = props.clarityQuestion.details;
    $[1] = props.clarityQuestion.question;
    $[2] = props.clarityQuestion.questionId;
    $[3] = props.clarityQuestion.slug;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
ClarityQuestionSEO.fragments = {
  ClarityQuestion: () => gql`
    fragment _ on ClarityQuestion {
      id
      slug
      questionId
      question
      topAnswer {
        id
        answerId
        answer
      }
    }
  `
};